<script>
import BScroll from 'better-scroll'
import { BROWSER_TIME, COMPS_SLIDING_PERCENTAGE } from 'base/config'
import { getScreenSize } from 'common/js/dom'
const PB_NAV_HEIGHT = 45
const NAV_HEIGHT = 40
const CDI_HEIGHT = 58
const CDIALL_HEIGHT = 173
const HD_HEIGHT = 40
const LEFT_WIDTH = 111
const LEFT_PERCENTAGE = 40 / 750
const ADDTAKE_HEIGHT = 60

export default {
  name: 'Demontable',
  props: {
    contrast: {
      type: Boolean,
      default: false
    },
    // 产品
    products: {
      type: Object
    },
    activeNavLeft: {
      type: Number,
      default: 0
    },
    // 当前利益演示
    profit: {
      type: Array
    },
    // 被保人年龄
    insuredAge: {
      type: Number,
      default: 0
    },
    propStartYear: {
      type: Number,
      default: 0
    },
    accountBtnsText: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    let {
      products: { list, value }
    } = this
    return {
      productList: list,
      productVal: value,
      // profitList: profit,
      tbSelectList: [],
      tbSelect: {
        show: false,
        value: null
      }
    }
  },
  computed: {
    curProduct () {
      let { productList, productVal } = this
      let result
      if (!productList.length) return {}
      productList.forEach((pd, index) => {
        if (productVal === pd.productId) {
          result = pd
        }
      })
      return result
    },
    profitLen () {
      const { profit } = this
      if (!Array.isArray(profit) || profit.length < 1) return 0
      let ary = profit.map(item => {
        return item.values.length
      })
      return profit[ary.indexOf(Math.max(...ary))].values.length
    },
    prdIndex () {
      let { productList, productVal } = this
      // 初始产品序列
      let pIdx = -1
      for (var i = 0, j = productList.length; i < j; i++) {
        if (productList[i].productId === productVal) {
          pIdx = i
        }
      }
      return pIdx
    },
    vbHeight () {
      const fontSize = document.querySelector('html').style.fontSize
      const rate = fontSize ? parseFloat(fontSize) / 50 : 1
      let navHeight = this.productList.length >= 1 ? NAV_HEIGHT * rate : 0
      let cdiHeight =
        this.curProduct.bonus && this.curProduct.rate
          ? CDIALL_HEIGHT * rate
          : this.curProduct.bonus || this.curProduct.rate
          ? CDI_HEIGHT * rate
          : 0

      return Math.ceil(
        this.visibleHeight -
          navHeight -
          cdiHeight -
          HD_HEIGHT -
          (this.contrast ? PB_NAV_HEIGHT * rate : 0) -
          (this.accountBtnsText.length ? ADDTAKE_HEIGHT * rate : 0)
      )
    },
    vbPartWidth () {
      let Len = this.profit.length
      Len = Len >= 3 ? 3 : Len
      return (this.visibleWidth - LEFT_WIDTH) / Len
    },
    profitBtnText () {
      let {
        curProduct: { bonus, rate }
      } = this
      let text = []
      if (bonus && rate) {
        let bonusDes = '',
          rateDes = ''
        if (Array.isArray(bonus.opts)) {
          for (var i = 0, j = bonus.opts.length; i < j; i++) {
            let option = bonus.opts[i]
            if (option.value === bonus.value) {
              bonusDes = option.description
              break
            }
          }
        }
        text.push(bonusDes)
        if (Array.isArray(rate.opts)) {
          for (var m = 0, n = rate.opts.length; m < n; m++) {
            let option = rate.opts[m]
            if (option.value === rate.value) {
              rateDes = `${Number(option.value * 100).toFixed(2)}%${
                option.description
              }`
              break
            }
          }
        }
        text.push(rateDes)
      }
      return text
    }
  },
  watch: {
    'products.value': {
      handler (newVal) {
        this.productVal = newVal
        this.$nextTick(() => {
          this.scroll && this.scroll.refresh()
          this.scroll2 && this.scroll2.refresh()
          this._refActiveLeft()
        })
      }
      // deep: true
    },
    profit: {
      handler (newVal) {
        this.profit = newVal
        // dom更新后刷新scroll
        this.$nextTick(() => {
          this.scroll && this.scroll.refresh()
          this.scroll2 && this.scroll2.refresh()
        })
      }
    }
  },
  mounted () {
    setTimeout(() => {
      this._initScroll()
      let navigation = document.querySelector(
        '.demontable-container .navigation'
      )
      let disLeft = this.visibleWidth * LEFT_PERCENTAGE
      navigation.scrollLeft = this.activeNavLeft + disLeft
    }, BROWSER_TIME)
  },
  created () {
    let { productList, productVal } = this
    // 初始产品序列
    for (var i = 0, j = productList.length; i < j; i++) {
      if (productList[i].productId === productVal) {
        this.pidx = i
      }
    }
    let screenSize = getScreenSize()
    this.visibleHeight = screenSize.height * COMPS_SLIDING_PERCENTAGE
    this.visibleWidth = screenSize.width
  },
  methods: {
    _initScroll () {
      if (!this.$refs.wrapper) return
      this.scroll = new BScroll(this.$refs.wrapper, {
        scrollX: true,
        probeType: 3,
        click: true
      })
      if (!this.$refs.dwrapper) return
      this.scroll2 = new BScroll(this.$refs.dwrapper, {
        scrollX: true,
        eventPassthrough: 'vertical',
        probeType: 3,
        click: true
      })
      this.scroll.on('scroll', pos => {
        this.scroll2.scrollTo(pos.x, 0)
      })
      this.scroll2.on('scroll', pos => {
        this.scroll.scrollTo(pos.x, 0)
      })
    },
    // 切换产品
    setHandler (index) {
      // this.pidx = index;
      this.$emit('tb-product-change', index)
    },
    // 切换利率
    setRateHandler () {
      let {
        curProduct: {
          rate: { value }
        },
        prdIndex
      } = this
      this.$emit('tb-rate-change', value, prdIndex)
    },
    // 切换分红
    setBonusHandler () {
      let {
        curProduct: {
          bonus: { value }
        },
        prdIndex
      } = this
      this.$emit('tb-bonus-change', value, prdIndex)
    },
    // 打开自定义下拉框
    tbHandler (type) {
      this.tbType = type
      let curOpts = this.curProduct[type].opts
      if (type === 'rate' && Array.isArray(curOpts)) {
        if (!curOpts[0].label) {
          curOpts.forEach(item => {
            item.label = `${(item.value * 100).toFixed(2)}%${item.description}`
          })
        }
      }
      this.tbSelectList = this.curProduct[type].opts
      this.tbSelect.value = this.curProduct[type].value
      this.tbSelect.show = true
    },
    // 自定义切换分红or利率
    tbSelectHandler (item) {
      let { tbType } = this
      this.curProduct[tbType].value = item.value
      this.tbSelect.show = false
      if (tbType === 'rate') {
        this.setRateHandler()
      } else if (tbType === 'bonus') {
        this.setBonusHandler()
      }
    },
    partHandler (index) {
      if (!this.accountBtnsText.length) return
      this.$emit('part-change', index)
    },
    _refActiveLeft () {
      // let activeItem = document.querySelector(
      //   '.demontable-container .navigation .cur'
      // )
      let navigation = document.querySelector(
        '.demontable-container .navigation'
      )
      let dnavigation = document.querySelector(
        '.demonstration-container .navigation'
      )
      dnavigation &&
        navigation &&
        (dnavigation.scrollLeft = navigation.scrollLeft)
    },
    _format (val) {
      return isNaN(val) ? '-' : Math.round(parseFloat(val))
    },
    _formatOptions (str) {
      return str.split('<br>').join(' ')
    }
  }
}
</script>

<template>
  <article v-if="profit" class="demontable-container">
    <div class="navigation-wrap after-bd-b">
      <div class="navigation" :class="{ 'after-bd-b': productList.length <= 3 }" @touchmove.stop>
        <nav class="nav">
          <a
            v-for="(pd, index) in productList"
            :key="index"
            href="javascript:;"
            class="item needsclick"
            :class="{ cur: productVal === pd.productId }"
            @click="setHandler(index)"
          >{{ _formatOptions(pd.productName) }}</a>
        </nav>
      </div>
    </div>
    <div
      v-if="curProduct && (curProduct.bonus || curProduct.rate)"
      class="condition"
      :class="{
        'gap': !accountBtnsText.length,
        'condition-sel': curProduct && curProduct.bonus && curProduct.rate
      }"
      @touchmove.stop.prevent
    >
      <!-- <div class="profit-condition-sel"
        v-if="curProduct && curProduct.bonus && curProduct.rate">
        <div class="tb-profit-btn after-bdr"
          @click="tbHandler('bonus')">
          <span>{{profitBtnText[0]}}</span>
          <i class="iconfont icon-arrow_down"></i>
        </div>
        <div class="tb-profit-btn after-bdr"
          @click="tbHandler('rate')">
          <span>{{profitBtnText[1]}}</span>
          <i class="iconfont icon-arrow_down"></i>
        </div>
        <select-list
          :list="tbSelectList"
          :propTb="tbSelect"
          @select="tbSelectHandler"
          @close="tbSelect.show = false"></select-list>
      </div>-->
      <div v-if="accountBtnsText.length" ref="addTake" class="add-take-reduce">
        <div class="inner">
          <a
            v-for="(item, index) in accountBtnsText"
            :key="index"
            href="javascript:;"
            :class="{ cur: index === products.part }"
            @click.stop.prevent="partHandler(index)"
          >{{ item }}</a>
        </div>
      </div>
      <div
        v-if="curProduct && curProduct.bonus && curProduct.rate"
        class="profit-condition condition-multiple"
        :class="{ 'gap': !accountBtnsText.length }"
      >
        <h6>分红水平</h6>
        <div class="bonus-condition">
          <span v-for="(curPd, index) in curProduct.bonus.opts" :key="index" class="profit-item">
            <input
              v-model="curProduct.bonus.value"
              type="radio"
              name="tb-bonus"
              :value="curPd.value"
              @change.stop="setBonusHandler"
            >
            <label class="profit-label after-bdr" for>
              <p class="profit-label-in" v-html="curPd.description" />
            </label>
          </span>
        </div>
        <h6>结算利率</h6>
        <div class="rate-condition">
          <span v-for="(curPd, index) in curProduct.rate.opts" :key="index" class="profit-item">
            <input
              v-model="curProduct.rate.value"
              type="radio"
              name="tb-rate"
              :value="curPd.value"
              @change.stop="setRateHandler"
            >
            <label for class="profit-label after-bdr">
              <template v-if="/\$/.test(curPd.description)">
                <p v-html="curPd.description.split('$')[0]" />
                <p v-html="curPd.description.split('$')[1]" />
              </template>
              <template v-else>
                <p v-html="`${(curPd.value * 100).toFixed(2)}%`" />
                <p v-html="curPd.description" />
              </template>
            </label>
          </span>
        </div>
      </div>

      <div
        v-if="curProduct && curProduct.bonus && !curProduct.rate"
        class="bonus-wrap profit-condition"
      >
        <span v-for="(curPd, index) in curProduct.bonus.opts" :key="index" class="profit-item">
          <input
            v-model="curProduct.bonus.value"
            type="radio"
            name="tb-bonus"
            :value="curPd.value"
            @change.stop="setBonusHandler"
          >
          <label class="profit-label after-bdr" for>
            <p class="profit-label-in" v-html="curPd.description" />
          </label>
        </span>
      </div>

      <div
        v-if="curProduct && curProduct.rate && !curProduct.bonus"
        class="rate-wrap profit-condition"
      >
        <span v-for="(curPd, index) in curProduct.rate.opts" :key="index" class="profit-item">
          <input
            v-model="curProduct.rate.value"
            type="radio"
            name="tb-rate"
            :value="curPd.value"
            @change.stop="setRateHandler"
          >
          <label for class="profit-label after-bdr">
            <template v-if="/\$/.test(curPd.description)">
              <p v-html="curPd.description.split('$')[0]" />
              <p v-html="curPd.description.split('$')[1]" />
            </template>
            <template v-else>
              <p v-html="`${(curPd.value * 100).toFixed(2)}%`" />
              <p v-html="curPd.description" />
            </template>
          </label>
        </span>
      </div>
    </div>
    <section class="demon-table">
      <header class="demon-hd after-bd-b">
        <div class="atribute">
          <div class="left" @touchmove.stop>
            <div class="ages">
              <div class="year">
                年度
              </div>
              <div class="year-age">
                年龄
              </div>
            </div>
          </div>
          <div ref="wrapper" class="main">
            <div class="slide">
              <div
                v-for="(col, index) in profit"
                :key="`${index}-${col.key}`"
                class="column"
                :style="{ width: `${vbPartWidth}px` }"
              >
                {{ col.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="markbar" />
      </header>
      <div class="demon-detail" :style="{ height: vbHeight + 'px' }">
        <div class="left" @touchmove.stop>
          <div v-for="(row, index) in profitLen" :key="index" class="line">
            <div class="item">
              {{ index + curProduct.startPolicyNo }}
            </div>
            <div class="item">
              {{ propStartYear + insuredAge + row }}
            </div>
          </div>
        </div>
        <div ref="dwrapper" class="main">
          <div class="slide">
            <div v-for="(row, index) in profitLen" :key="index" class="row">
              <div
                v-for="(col, idx) in profit"
                :key="`${index}-${idx}`"
                class="col"
                :style="{ width: vbPartWidth + 'px' }"
              >
                {{ _format(col.values[index]) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </article>
  <div v-else class="loading" />
</template>

<style lang="postcss" scoped>
@import 'variable.css';
.demontable-container {
  background-color: white;
  user-select: none;
  touch-callout: none;
  .profit-condition {
    margin-bottom: 0;
  }
}
.condition {
  &.gap {
    padding-top: 10px;
  }
  padding-bottom: 10px;
  text-align: center;
  .bonus-wrap,
  .rate-wrap {
    /*display: inline-block;*/
    /*border-radius: 2px;*/
    &:after {
      border-radius: 6px;
    }
    .condition-sel {
      z-index: 1;
      position: relative;
      min-width: 115px;
      padding: 5px 25px 5px 10px;
      font-size: 15px;
      border: 0;
      vertical-align: middle;
      appearance: none;
      background: transparent;

      -webkit-tap-highlight-color: transparent;
    }
    .icon-arrow_down {
      z-index: 1;
      position: absolute;
      right: 8px;
      top: 50%;
      font-size: 12px;
      line-height: 1;
      pointer-events: none;
      transform: translateY(-50%) scale(0.7);
    }
  }
}

.condition-sel {
  padding: 0;
}

.profit-condition-sel {
  display: flex;
  padding: 10px 30px;
  .tb-profit-btn {
    flex: 1;
    margin: 0 5px;
    padding: 5px 25px 5px 5px;
    span {
      display: block;
      max-width: 120px;
      @apply --text-ellipsis;
    }
    .icon-arrow_down {
      position: absolute;
      right: 5px;
      top: 50%;
      font-size: 12px;
      line-height: 1;
      transform: translateY(-50%) scale(0.7);
      transform-origin: left top;
      pointer-events: none;
    }
  }
}

.add-take-reduce {
  padding: 0.3rem;
  text-align: center;
  .inner {
    overflow-x: auto;
    width: 70%;
    margin: 0 auto;
    border-width: 1px;
    border-style: solid;
    font-size: 0;
    border-radius: 10rem;
    white-space: nowrap;
    &::-webkit-scrollbar {
      width: 0px;
      display: none;
    }
    a {
      display: inline-block;
      width: 50%;
      padding: 0.18rem 0.24rem;
      font-size: 0.3rem;
      text-decoration: none;
      border-radius: 10rem;
    }
  }
}

.condition-multiple {
  display: block;
  padding-bottom: 0.3rem;
  &.gap {
    padding-top: 0.2rem;
  }
  > h6 {
    padding-top: 12px;
    padding-bottom: 9px;
    color: #333;
    font-size: 12px;
    text-align: left;
  }
  .bonus-condition,
  .rate-condition {
    display: flex;
  }
  .bonus-condition {
    .profit-item {
      .profit-label {
        padding: 7px;
        p {
          line-height: 1.2;
        }
      }
    }
  }
}

.demon-table {
  color: #666;
  background-color: #fff;
  border-top: 1px solid var(--primary-color-border);
  &:before {
    z-index: 1;
    @apply --bd-h;
    background-color: var(--primary-color-border);
    left: 0;
    top: 0;
  }
  .left {
    display: table-cell;
    width: 112px;
    text-align: center;
    .line:nth-child(2n) {
      background-color: var(--minor-color-bg);
    }
  }
  .main {
    overflow: hidden;
    position: relative;
    display: table-cell;
    touch-action: pan-y pinch-zoom;
    -webkit-tap-highlight-color: transparent;
    .slide {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      margin-left: -1px;
      font-size: 0;
      white-space: nowrap;
      &:after {
        @apply --bd-w;
        background-color: var(--primary-color-border);
        left: 0;
        top: 0;
      }
      .row:nth-child(2n) {
        background-color: var(--minor-color-bg);
      }
    }
  }
  .atribute {
    display: table;
    width: 100%;
    height: 40px;
    line-height: 40px;
    .left {
      .ages {
        display: flex;
        width: 112px;
        border-right: 1px solid var(--primary-color-border);
      }
      .year,
      .year-age {
        flex: 1;
      }
      .year {
        border-right: 1px solid var(--primary-color-border);
      }
    }
    .column {
      display: inline-block;
      width: 98px;
      text-align: center;
      font-size: 14px;
      border-right: 1px solid var(--primary-color-border);
      @apply --text-ellipsis;
    }
  }
  .demon-detail {
    /*display: table;*/
    overflow-y: auto;
    width: 100%;
    height: 300px;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    /* -webkit-overflow-scrolling: touch; */
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
      display: none;
      background-color: transparent;
    }
    .main {
      width: 100%;
    }
    .data {
      font-size: 16px;
    }
    .line,
    .row {
      font-size: 14px;
      font-weight: normal;
      border-bottom: 1px solid var(--primary-color-border);
    }
    .line {
      width: 112px;
      display: flex;
      &:first-child {
        position: relative;
        &:before {
          @apply --bd-h;
          background-color: var(--primary-color-border);
          left: 0;
          top: 0;
        }
      }
    }
    .item,
    .col {
      flex: 1;
      height: 40px;
      min-width: 56px;
      line-height: 40px;
      border-right: 1px solid var(--primary-color-border);
      @apply --text-ellipsis;
    }
    .row {
      display: flex;
      white-space: nowrap;
      &:first-child:before {
        @apply --bd-h;
        background-color: var(--primary-color-border);
        left: 0;
        top: 0;
      }
    }
    .col {
      width: 98px;
      text-align: center;
    }
  }
}

@media screen and (device-width <= 320px) {
  .demon-table .atribute .left .year,
  .demon-table .atribute .left .year-age,
  .demon-table .atribute .column {
    font-size: 12px;
  }
}
</style>
